import * as React from "react";

export interface IFancyDropdownIconModePrompt {
  itemID?: string;
  text: string;
  fontAwesomeIcon?: string;
  tabIndex?: number;
  onFocussed?: (itemID: string) => any;
}

export const FancyDropdownIconModePrompt = (props: IFancyDropdownIconModePrompt) => {

  const icon = props.fontAwesomeIcon === undefined ? "fa-star" : props.fontAwesomeIcon; // Default to a star icon if no icon specified.
  const emCSSclasses = "fa " + icon;

  const onFocus = () => { if (props.onFocussed) { props.onFocussed(props.itemID); } };

  const onClicked = (event) => { event.preventDefault(); };

  return (
    <a className="CAL-dropdownButton CAL-button CAL-square js-nav-system__link" href="#!" tabIndex={props.tabIndex} onFocus={onFocus} onClick={onClicked}>
      <span className="offScreen">{props.text}</span>
      <em className={emCSSclasses} aria-hidden="true"></em>
    </a>
  );
};
